// Build a `seed` object for the Add New Deal modal from an existing
// listing-request or buyer-request deal. Pure function — no IO, no React.
//
// The seed shape mirrors the modal's four step state slices, plus:
//   - source: "listing" | "buyer" — for UI label ("From listing" vs "From buyer request")
//   - prefilled: { [fieldName]: true } — flags so the modal can decorate
//     prefilled inputs (amber border, "From X" subtitle). Only set for
//     fields that were actually populated from the source, not defaults.
export function buildTurnInSeed(source) {
  if (!source) return null;

  const isBuyer = source.dealtype === "Buyer";

  const prefilled = {};
  const mark = (key, val) => {
    if (val !== undefined && val !== null && val !== "") prefilled[key] = true;
    return val;
  };

  return {
    source: isBuyer ? "buyer" : "listing",
    prefilled,
    step1: {
      mlsNumber: "",
      propertyType: mark("propertyType", source.propertyType) || "",
      earnestMoney: 0,
      offerPrice: 0,
      // Always a sale stage — that's what "turn-in" means.
      dealStage: "Under Contract",
      inspection: "",
      financingType: "",
      propertyaddress: mark("propertyaddress", source.propertyaddress) || "",
      closingdate: new Date().toISOString().slice(0, 10),
      financingDeadline: "",
      inspectionDeadline: "",
      propertyphoto: mark("propertyphoto", source.propertyphoto) || "",
      propertyphotodata: source.propertyphotodata || "",
      propertyLocation: source.propertyLocation
        ? (mark("propertyLocation", source.propertyLocation), source.propertyLocation)
        : null,
    },
    step2: {
      clientType: mark("clientType", isBuyer ? "Buyer" : "Seller"),
      clientinfo:
        Array.isArray(source.customers) && source.customers.length > 0
          ? (mark("clientinfo", source.customers), source.customers)
          : [""],
    },
    step3: {
      teamleadName: "",
      assignedteamlead: "",
      agentName: mark("agentName", source.agentName) || "",
      agentid: mark("agentid", source.agentData) || "",
      leadsource: mark("leadsource", source.leadsource) || "",
      propertyAddress: source.propertyaddress || "",
      agentCommission: 0,
      thirdpartyagentCommission: 0,
      thirdpartyagentName: "",
      fixedagentcommission: false,
      leadCommission: source.leadsource?.leadCommission || 0,
      splittype: source.splittype || "TeamSplit",
      inhousereferral: false,
      splitdescription: source.splitdescription || "Team Member Split",
      brokeradminfee: 0,
      captype: source.captype || "pre",
      captypedescription:
        source.captypedescription || "Pre-Cap (90/10 Split)",
    },
    step4: {
      flatfee: false,
      flatfeeamount: 0,
      totalcommissionrate: mark(
        "totalcommissionrate",
        source.totalcommissionrate
      ) || 0,
      buyersidecommissionrate: "",
      sellersidecommissionrate: "",
      teamleadcommissionrate: "",
      agentCommissionamount: 0,
      teamleaddiscount: 0,
      agentdiscount: 0,
      leadsourceCommissionamount: 0,
      teamleadCommissionamount: 0,
      totalCommissionamount: 0,
      bankcommission: 0,
      thirdpartyagentcommissionamount: 0,
      takehomecommissionamount: 0,
    },
  };
}
